<!-- Router Outlet -->
<router-outlet></router-outlet>
<app-inactivity-warning></app-inactivity-warning>
@if (isAuthenticated()) {
  <app-common-chat-button></app-common-chat-button>
}
<app-cookie-consent-banner></app-cookie-consent-banner>
